import { render, staticRenderFns } from "./CustomProductAddToCart.vue?vue&type=template&id=c923612a&scoped=true&name=the-cart-section&"
import script from "./CustomProductAddToCart.vue?vue&type=script&lang=js&"
export * from "./CustomProductAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductAddToCart.vue?vue&type=style&index=0&id=c923612a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c923612a",
  null
  
)

/* custom blocks */
import block0 from "./CustomProductAddToCart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports